module.exports = new __parcel__URL__("ICGC_white.9dc19513.svg").toString();